<template>
  <div>
    <div class="container-fluid">
      <Breadcrumbs main="Рейтинг" title="История рейтинга команд турнира"/>
      <b-card>
        <div>
          <b-form>
            <!-- Лоадер для всего списка -->
            <div v-if="isLoadingList" class="loading-wrapper">
              <b-spinner class="spinner"></b-spinner>
            </div>

            <div v-else>
              <b-table
                  responsive
                  show-empty
                  stacked="md"
                  :striped="striped"
                  :bordered="bordered"
                  :fields="fields"
                  :items="tournamentTeamsRatingList"
                  :current-page="0"
                  :per-page="10"
                  class="mb-5"
              >
                <template v-slot:cell(id)="{ item }">
                  {{ item.id }}
                </template>
                <template v-slot:cell(team)="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:cell(rating)="{ item }">
                  {{ item.tournament_rating_points }}
                </template>
                <template #cell(details)="data">
                  <div class="d-flex justify-content-center">
                    <b-button size="lg" @click="showTeamRatingsDetails(data)" class="px-1 py-0 d-flex" variant="none">
                      <i class="fa fa-arrow-circle-o-down"></i>
                    </b-button>
                  </div>
                </template>

                <template #row-details="data">
                  <div class="card p-0 m-0">
                    <!-- Лоадер для конкретной команды -->
                    <div v-if="detailsLoading[data.item.id]" class="d-flex justify-content-center py-4">
                      <b-spinner class="spinner"></b-spinner>
                    </div>
                    <!-- Детали команды -->
                    <b-table
                        v-else
                        :items="teamDetails[data.item.id] || []"
                        :fields="oneTeamRatingsFields"
                        striped
                        hover
                        responsive
                        show-empty
                    >
                      <template #cell(stage)="data">
                        {{ data.item?.ratingStage?.name }}
                      </template>
                      <template #cell(group)="data">
                        {{ data.item?.ratingGroup?.name }}
                      </template>
                      <template #cell(coeff_rating)="data">
                        {{ data.item?.ratingStage?.rating_coefficient }}
                      </template>
                      <template #cell(coeff_personal_rating)="data">
                        {{ data.item?.ratingStage?.player_rating_coefficient }}
                      </template>
                      <template #cell(matches_count)="data">
                        {{ data.item?.ratingStage?.match_count }}
                      </template>
                      <template #cell(point)="data">
                        {{ data.item?.point }}
                      </template>
                      <template #cell(date)="data">
                        {{ data.item.created_at }}
                      </template>
                    </b-table>
                  </div>
                </template>
              </b-table>

              <b-col md="6" class="p-0">
                <pagination-rating :total="Math.ceil(pagination.total / pagination.by)" />
              </b-col>
            </div>
          </b-form>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import api from '/src/api/api';
import PaginationRating from "@/pages/Rating/components/PaginationRating.vue";

export default {
  name: "TournamentTeamsRatingInfo",
  components: { PaginationRating },
  data() {
    return {
      tournamentTeamsRatingList: [],
      teamDetails: {}, // данные по каждой команде
      pagination: {},
      pageKey: 'tournamentTeamsRatingPageNumber',
      fields: [
        { key: 'id', label: 'id', sortable: true },
        { key: 'team', label: 'Команда', sortable: true },
        { key: 'rating', label: 'Общий рейтинг', sortable: true },
        { key: 'details', label: 'Подробнее' },
      ],
      oneTeamRatingsFields: [
        { key: 'id', label: 'id', sortable: true },
        { key: 'stage', label: 'Стадия', sortable: true },
        { key: 'group', label: 'Группа', sortable: true },
        { key: 'coeff_rating', label: 'Коэфицент рейтинга', sortable: true },
        { key: 'coeff_personal_rating', label: 'Коэфицент игрока', sortable: true },
        // { key: 'matches_count', label: 'Количество матчей', sortable: true },
        { key: 'point', label: 'Рейтинг', sortable: true },
        { key: 'date', label: 'Дата', sortable: true },
      ],
      striped: true,
      bordered: true,
      isLoadingList: false,
      detailsLoading: {}, // статус загрузки по id команды
    };
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler() {
        this.fetchTournamentTeams();
      }
    }
  },
  methods: {
    async fetchTournamentTeams() {
      try {
        this.isLoadingList = true;
        const page = parseInt(this.$route.query.page) || 1;
        const response = await api.tournamentsRating.index({
          tournId: this.$route.params.id,
          page,
        });
        this.tournamentTeamsRatingList = response.data?.teams || [];
        this.pagination = response.data?.pagination || {};
      } catch (error) {
        console.error('Ошибка загрузки команд турнира:', error);
      } finally {
        this.isLoadingList = false;
      }
    },
    async showTeamRatingsDetails(data) {
      const teamId = data.item.id;

      // если уже раскрыта — свернуть без запроса
      if (data.detailsShowing) {
        data.toggleDetails();
        return;
      }

      // если уже есть данные — просто открыть
      if (this.teamDetails[teamId]) {
        data.toggleDetails();
        return;
      }

      // сначала открываем строку (отрисуется row-details)
      data.toggleDetails();

      // затем запускаем лоадер
      this.$set(this.detailsLoading, teamId, true);

      try {
        const response = await api.tournamentsRating.show({
          tournId: this.$route.params.id,
          teamId,
        });
        const details = response?.data?.rating || [];
        this.$set(this.teamDetails, teamId, details);
      } catch (error) {
        console.error(`Ошибка загрузки деталей команды ${teamId}:`, error);
      } finally {
        this.$set(this.detailsLoading, teamId, false);
      }
    }

  }
};
</script>
